import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";
import moment, { Moment } from "moment";
import BasicDatePicker from "../../../../../../../../components/BasicDatePicker";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { usePermission } from "../../../../../../../../components/PermissionGuard";

export default function DialogSelecionarData({
  open,
  handleClose,
  blockPastDates = false,
  blockFutureDates = false,
  minDate,
}: DialogSelecionarDataProps) {
  const { getValues, setValue } = useFormContext();
  const [date, setDate] = useState(getValues("finalizacao.data_recebimento"));

  const handleSubmit = () => {
    setValue("finalizacao.data_recebimento", date);
    handleClose();
  };

  const podeDataRetroativa = usePermission("financeiro.contas-receber-data-retroativa");
  const podeDataFutura = usePermission("financeiro.contas-receber-data-futura");

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
      scroll="body"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        Selecionar data do recebimento
      </DialogTitle>

      <DialogContent>
        <Box py={1}>
          <BasicDatePicker
            blockPastDates={blockPastDates}
            blockFutureDates={podeDataFutura ? false : blockFutureDates} // Força false se tiver permissão
            value={date}
            label="Data recebimento"
            onChange={(data) => setDate(data as Moment)}
            formatString="DD/MM/YYYY"
            pastDates={podeDataRetroativa ? minDate : moment()}
            futureDates={podeDataFutura ? undefined : moment()}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button autoFocus variant="contained" onClick={handleSubmit}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogSelecionarDataProps {
  open: boolean;
  handleClose: () => void;
  blockPastDates?: boolean;
  blockFutureDates?: boolean;
  minDate?: Moment;
}